import InteractionInsight from '@/lib/insights/models/InteractionInsight';
import { User } from '@/lib/business';
import ContentAccessRequestInfo from '@/lib/documents/models/ContentAccessRequestInfo';

class DocumentInsightsClient {
  /**
   *
   * @type {AxiosInstance}
   */
  httpClient = null;

  baseUrl = 'v2/assets/';

  /**
   *
   * @param httpClient{AxiosInstance}
   */
  constructor(httpClient) {
    this.httpClient = httpClient;
  }

  /**
   *
   * @param docId
   * @returns {Promise<InteractionInsight>}
   */
  async getInsight(docId) {
    const url = `${this.baseUrl}${docId}/insights`;
    const { data } = await this.httpClient.get(url);

    return InteractionInsight.fromObject(data);
  }

  async like(docId) {
    const url = `${this.baseUrl}${docId}/insights/likes`;

    try {
      await this.httpClient.post(url);
    } catch (e) {
      console.error(e);
    }

    return this.getInsight(docId);
  }

  async unLike(docId) {
    const url = `${this.baseUrl}${docId}/insights/likes`;

    try {
      await this.httpClient.delete(url);
    } catch (e) {
      console.error(e);
    }
    return this.getInsight(docId);
  }

  async markViewed(docId) {
    const url = `${this.baseUrl}${docId}/insights/views`;

    try {
      await this.httpClient.post(url);
    } catch (e) {
      console.error(e);
    }
    return this.getInsight(docId);
  }

  async markShared(docId) {
    const url = `${this.baseUrl}${docId}/insights/shares`;

    try {
      await this.httpClient.post(url);
    } catch (e) {
      console.error(e);
    }
    return this.getInsight(docId);
  }

  /**
   *
   * @param docId
   * @returns {Promise<User|null>}
   */
  async uploader(docId) {
    const url = `${this.baseUrl}${docId}/info/uploader`;
    try {
      const { data } = await this.httpClient.get(url);
      const uploader = data.data;

      return new User(uploader);
    } catch (e) {
      return null;
    }
  }

  /**
   *
   * @param docId
   * @returns {Promise<ContentAccessRequestInfo|null>}
   */
  async contentAccessRequestInfo(docId) {
    const url = `${this.baseUrl}${docId}/info/contentAccessRequestInfo`;
    try {
      const { data } = await this.httpClient.get(url);
      const info = new ContentAccessRequestInfo(data.data);
      return info;
    } catch (e) {
      return null;
    }
  }
}

export default DocumentInsightsClient;
